import React, { useEffect, useState } from "react";
import "../../Style.css";
import "../../Brand.css";
import {
  Button,
  Container,
  Grid,
  Box,
  Stack,
  Typography,
  Avatar,
  Link,
  Tab,
  Card,
  Checkbox,
  IconButton,
  TextField,
  FormControl,
} from "@mui/material";
import PropTypes from "prop-types";
import Infopoint_Logo from "../../images/Infopoint.png";
import up_arrow from "../../images/up-arrow.png";
import EventIcon from "@mui/icons-material/Event";
import PlaceIcon from "@mui/icons-material/Place";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useParams, useSearchParams } from "react-router-dom";

// Modal
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import VerifiedIcon from "@mui/icons-material/Verified";
import ServiceItem from "./ServiceItem";
import { connectToStore } from "../../data/store";
import UserHelper from "../../core/UserHelper";
import { PostAsyncAnonymous } from "../../core/serviceClient";
import Utils from "../../core/Utils";
import { equals } from "validator";
import moment from "moment";
import PublicReservationHelper from "../../core/PublicReservationHelper";
import Tabs, { tabsClasses } from "@mui/material/Tabs";
import Loader from "../common/Loader";
import { SuccessDialog } from "../common/SuccessDialog";
import MessagePopup from "../common/MessagePopUp";
import { India, CustomerBookingActions } from "../../core/Constants";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Stack spacing={2}>{children}</Stack>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const BrandHome = () => {
  const { BrandPath } = useParams();
  const [searchParams] = useSearchParams(); // Get query parameters

  useEffect(() => {
    //getEncryptedData();
    const encryptedData = searchParams.get("data");
    getDecryptedData(encryptedData);
  }, [searchParams, BrandPath]);

  var body = document.body;
  body.classList.add("brandHome");

  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);

  const [localSettings, setLocalSettings] = useState({});
  const [serviceValue, setServiceValue] = useState(0);
  const [timeValue, setTimeValue] = useState(0);
  const [checked, setChecked] = useState(true);
  const [showServies, setShowServies] = useState(true);
  const [showTime, setShowTime] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [serviceList, setServiceList] = useState([]);
  const [serviceCategory, setServiceCategory] = useState([]);
  const [categorizedServices, setCategorizedServices] = useState({});
  const [selectedServices, setSelectedServices] = useState([]);
  const [branchDetails, setBranchDetails] = useState(null);
  const [branchLogoURL, setBranchLogoURL] = useState(null);
  const [showOTP, setShowOTP] = useState(false);
  const [showMobileNo, setShowMobileNo] = useState(false);
  const [isConfirmBooking, setIsConfirmBooking] = useState(false);

  const [reservations, setReservations] = useState([]);
  const [openReservationDetails, setOpenReservationDetails] = useState([]);
  const [closedReservationDetails, setClosedReservationDetails] = useState([]);
  const [reservationDetails, setReservationDetails] = useState({});
  const [serviceStartTime, setServiceStartTime] = useState("");
  const [serviceEndTime, setServiceEndTime] = useState("");

  const [selectedDate, setSelectedDate] = useState([
    moment().utc(),
    moment().utc().add(7, "days").endOf("day"),
  ]);
  const [selectedTime, setSelectedTime] = useState("");
  const [selectedTimestring, setSelectedTimeString] = useState("");
  const [selectedDaystring, setSelectedDaystring] = useState("");
  const [selectedMonthString, setSelectedMonthString] = useState("");
  const [businessId, setBusinessId] = useState("");
  const [branchId, setBranchId] = useState("");
  const [customerMobileNumber, setCustomerMobileNumber] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [otpId, setOTPId] = useState("");
  const [otp, setOTP] = useState("");
  const [customerBookingAction, setCustomerBookingAction] = useState("");
  const [socialMediaSource, setSocialMediaSource] = useState("");

  const totalAmount = selectedServices?.reduce((sum, serviceId) => {
    const service = serviceList.find((x) => x.id === serviceId);
    return sum + (service?.price || 0);
  }, 0);

  const totalTime = selectedServices?.reduce((sum, serviceId) => {
    const service = serviceList.find((x) => x.id === serviceId);
    return sum + (service.serviceTime + service.postServiceTime);
  }, 0);

  const handleServiceTabsChange = (event, newValue) => {
    setServiceValue(newValue);
  };

  const closeSuccess = () => {
    setShowSuccess(false);
  };
  const closeAlert = () => {
    setShowAlert(false);
    if (customerBookingAction === CustomerBookingActions.WrongOTP) {
      setShowOTP(true);
    }
  };

  const handleTimeTabsChange = (event, newValue) => {
    setTimeValue(newValue);
  };

  const handleCheckboxChange = (event) => {
    setChecked(event.target.checked);
  };

  const handleToggle = (serviceId) => {
    setSelectedServices(
      (prevSelected) =>
        prevSelected.includes(serviceId)
          ? prevSelected.filter((id) => id !== serviceId) // uncheck
          : [...prevSelected, serviceId] // check
    );
  };

  const handleShowTime = (event) => {
    if (Utils.IsNullOrEmptyArray(selectedServices)) {
      setAlertMessage("Please select service");
      setShowAlert(true);
      return;
    }
    setShowServies(false);
    setShowTime(true);
  };

  const handleShowServices = (event) => {
    setShowServies(true);
    setShowTime(false);
  };

  const handleClickOpenModal = () => {
    if (
      !Utils.IsNullOrEmpty(selectedTimestring) &&
      !Utils.IsNullOrEmpty(selectedDaystring)
    ) {
      setOpenModal(true);
      setShowMobileNo(true);
    } else {
      setAlertMessage("Please select time");
      setShowAlert(true);
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setShowOTP(false);
    setIsConfirmBooking(false);
  };

  const GetAllServices = async (BusinessId) => {
    var requestBody = {
      BusinessId: BusinessId,
      QueryParameters: [BusinessId],
      QueryId: "GetAllProductsByBusiness",
    };
    let result = await PostAsyncAnonymous("Branch/GetProduct", requestBody);
    if (!Utils.IsNullOrEmptyArray(result.data)) {
      const listofServices = result.data;
      setServiceList(listofServices);
      const distinctServiceCategories = [
        ...new Set(
          listofServices.map((Service) => Service.class).filter(Boolean)
        ),
      ];
      distinctServiceCategories.unshift("All Services");
      setServiceCategory(distinctServiceCategories);

      // Group services by their 'Class' property
      const categorizedServices = listofServices.reduce((acc, service) => {
        const className = service.class || "Uncategorized"; // Default to 'Uncategorized' if no class
        if (!acc[className]) {
          acc[className] = [];
        }
        acc[className].push(service);
        return acc;
      }, {});
      setCategorizedServices(categorizedServices);
    }
  };

  const GetBranchDetails = async (BusinessId, BranchId) => {
    var requestBody = {
      BusinessId: BusinessId,
      BranchId: BranchId,
    };
    let result = await PostAsyncAnonymous(
      "Branch/GetBranchInformation",
      requestBody
    );

    if (!Utils.IsNullOrEmptyArray(result.data)) {
      const branchinfo = result.data.branch;
      const branchLogo = result.data.logoUrl;
      setBranchDetails(branchinfo);
      setBranchLogoURL(branchLogo);

      document.title = branchinfo.branchName;

      setServiceStartTime(branchinfo.startTime);
      setServiceEndTime(branchinfo.endTime);
    }
  };

  const getReservationDetail = async (
    startDate,
    endDate,
    businessId,
    branchId
  ) => {
    setLoading(true);

    var startDT = Utils.GetISODateTimeString(startDate);
    var endDT = Utils.GetISODateTimeString(endDate);

    var Data = {
      BusinessId: businessId,
      BranchId: branchId,
      Start: startDT,
      End: endDT,
      GetReservations: true,
      GetAvailableTimeSlots: true,
      GetProducts: false,
      SelectedLocalDT: startDT,
    };

    var requestBody = {
      BusinessId: businessId,
      BranchId: branchId,
      Data: Data,
    };

    var result = await PostAsyncAnonymous(
      "Branch/GetReservationSlots",
      requestBody
    );
    if (!result.error) {
      const tempreservationsData = result.data;
      setReservationDetails(tempreservationsData);
    }

    setLoading(false);
  };

  const handleOpenOTPModal = async () => {
    if (
      Utils.IsNullOrEmpty(customerMobileNumber) ||
      0 === customerMobileNumber.length ||
      Utils.IsNullOrEmpty(customerName) ||
      0 === customerName.length
    ) {
      setAlertMessage("Please enter mobile number and name");
      setShowAlert(true);
      return;
    }
    if (!Utils.IsMobileValid(customerMobileNumber, branchDetails.CountryCode)) {
      setAlertMessage("Entered mobile number is not valid");
      setShowAlert(true);
      return;
    }

    setShowMobileNo(false);
    setShowOTP(true);

    var id = customerMobileNumber;

    var request = {
      Data: {
        MobileNumber: customerMobileNumber,
        EmailId: "",
        CountryCode: branchDetails.countryCode,
        OTPId: id,
        BusinessId: businessId,
      },
    };
    setLoading(true);
    let result = await PostAsyncAnonymous(
      "Branch/ValidateReservation",
      request
    );
    setLoading(false);
    setLoading(false);
    if (result.error) {
      setAlertMessage(result.errorMessage);
      setShowAlert(true);
      return;
    }
    setOTP("");
    setOTPId(id);
    setShowOTP(true);
  };

  const handleConfirmBookingModal = async () => {
    var request = {
      Data: {
        OTP: otp,
        UserId: otpId,
      },
    };
    setLoading(true);
    let result = await PostAsyncAnonymous(
      "Branch/AuthenticateReservationOTP",
      request
    );
    setLoading(false);
    if (result.error) {
      setShowOTP(false);
      setOTP("");
      setAlertMessage(result.errorMessage);
      setShowAlert(true);
      setCustomerBookingAction(CustomerBookingActions.WrongOTP);
      return;
    }

    if (result.data) {
      setShowOTP(false);
      setCustomerBookingAction(CustomerBookingActions.ProceedReservation);
      reservation();
    }
  };

  const getEncryptedData = async () => {
    var requestBody = {
      Data: {
        PlainText: "B20252#001#Facebook",
      },
    };
    let result = await PostAsyncAnonymous(
      "Branch/GetEncryptedString",
      requestBody
    );
    if (!Utils.IsNullOrEmptyArray(result.data)) {
      const encytemp = result.data;
      console.log("Encrypted Data: ", encytemp);
    }
  };

  const getDecryptedData = async (encryptedData) => {
    var requestBody = {
      Data: {
        EncryptedData: encryptedData,
      },
    };
    let result = await PostAsyncAnonymous(
      "Branch/GetDecryptedString",
      requestBody
    );
    if (!Utils.IsNullOrEmptyArray(result.data)) {
      const decryptedDatatemp = result.data;
      let localSetting = connectToStore();
      setLocalSettings(localSetting);

      const businessId = decryptedDatatemp?.split("#")[0];
      const branchId = decryptedDatatemp?.split("#")[1];
      const socialMediaSource = decryptedDatatemp?.split("#")[2];

      console.log("BusinessId: ", businessId);
      console.log("BranchId: ", branchId);
      console.log("SocialMediaSource: ", socialMediaSource);

      setBusinessId(businessId);
      setBranchId(branchId);
      setSocialMediaSource(socialMediaSource);
      setLoading(true);

      GetAllServices(businessId);
      GetBranchDetails(businessId, branchId);

      getReservationDetail(
        selectedDate[0],
        selectedDate[1],
        businessId,
        branchId
      );

      setLoading(false);
    }
  };

  const reservation = async () => {
    var reservationDT = PublicReservationHelper.getReservationDateTime(
      selectedTimestring,
      selectedDaystring,
      selectedMonthString,
      serviceStartTime
    );
    var serviceItemList = [];
    if (!Utils.IsNullOrEmptyArray(selectedServices)) {
      selectedServices.forEach((serviceId) => {
        var serviceItem = serviceList.find((x) => x.id === serviceId);
        serviceItemList.push(serviceItem);
      });
    }
    var reservationRequest = {
      Data: {
        CustomerName: customerName,
        MobileNumber: customerMobileNumber?.trim(),
        BusinessId: businessId,
        BranchId: branchId,
        SocialMediaSource: socialMediaSource,
        CountryCode: branchDetails.countryCode,
        ReservationDT: reservationDT,
        Services: Utils.IsNullOrEmptyArray(serviceItemList)
          ? null
          : serviceItemList,
      },
    };
    setLoading(true);
    let result = await PostAsyncAnonymous(
      "Branch/SaveBooking",
      reservationRequest
    );
    setLoading(false);
    if (result.error) {
      setAlertMessage(result.errorMessage);
      setShowAlert(true);
      setCustomerName("");
      setCustomerMobileNumber("");
      setSelectedServices([]);
      setSelectedTime("");
      setSelectedTimeString("");
      setSelectedDaystring("");
      setSelectedMonthString("");
      setOpenModal(false);
      setShowOTP(false);
      setIsConfirmBooking(false);
      setShowTime(false);
      setShowServies(true);
      return;
    }
    setIsConfirmBooking(true);
    body.classList.add("bookingConfirmed");
    setCustomerName("");
    setCustomerMobileNumber("");
    setSelectedServices([]);
    setSelectedTime("");
    setSelectedTimeString("");
    setSelectedDaystring("");
    setSelectedMonthString("");
    setShowSuccess(true);
    setShowTime(false);
    setShowServies(true);
    setTimeout(
      function () {
        setOpenModal(false);
        setShowOTP(false);
        setIsConfirmBooking(false);
      }.bind(this),
      3000
    );
  };

  return (
    <Container maxWidth="false" sx={{ paddingBottom: "8rem" }}>
      <Loader open={loading} />
      <Dialog
        open={openModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseModal}
        aria-describedby="alert-dialog-slide-description"
        className="booknow-modal"
      >
        {showOTP && (
          <>
            <DialogTitle fontSize="2.4rem" fontWeight="700">
              {"OTP Verification"}
              <Typography fontSize="16px">
                Enter the 6 digit code received your mobile
              </Typography>
              <IconButton
                onClick={handleCloseModal}
                title="Close"
                sx={{ position: "absolute", right: "10px", top: "10px" }}
              >
                <CloseOutlinedIcon sx={{ fontSize: "24px" }} />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                <FormControl fullWidth className="otp-field">
                  <TextField
                    name=""
                    placeholder="000000"
                    value={otp}
                    onChange={(e) => setOTP(e.target.value)}
                    inputProps={{ maxLength: 6 }}
                  />
                </FormControl>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                className="submitBtn cs-btn"
                fullWidth="true"
                onClick={handleConfirmBookingModal}
              >
                Confirm
              </Button>
            </DialogActions>
          </>
        )}

        {showMobileNo && (
          <>
            <DialogTitle fontSize="2.4rem" fontWeight="700">
              <Typography fontSize="16px">Sign up with your</Typography>
              {"Mobile Number"}
              <IconButton
                onClick={handleCloseModal}
                title="Close"
                sx={{ position: "absolute", right: "10px", top: "10px" }}
              >
                <CloseOutlinedIcon sx={{ fontSize: "24px" }} />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                <FormControl fullWidth>
                  <TextField
                    name=""
                    placeholder="Mobile Number"
                    value={customerMobileNumber}
                    onChange={(e) => setCustomerMobileNumber(e.target.value)}
                  />
                </FormControl>
              </DialogContentText>
            </DialogContent>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                <FormControl fullWidth>
                  <TextField
                    name=""
                    placeholder="Name"
                    value={customerName}
                    onChange={(e) => setCustomerName(e.target.value)}
                  />
                </FormControl>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                className="submitBtn cs-btn"
                fullWidth="true"
                onClick={handleOpenOTPModal}
              >
                Get OTP
              </Button>
            </DialogActions>
          </>
        )}

        {isConfirmBooking && (
          <Box className="confirmed-box" id="confirmBox">
            <DialogTitle>
              <IconButton
                onClick={handleCloseModal}
                title="Close"
                sx={{ position: "absolute", right: "10px", top: "10px" }}
              >
                <CloseOutlinedIcon sx={{ fontSize: "24px" }} />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <DialogContentText
                className="text-center"
                sx={{ color: "#000000" }}
              >
                <VerifiedIcon
                  sx={{ fontSize: "8rem", color: "rgb(76 175 80)" }}
                />
                <Typography fontSize="20px">Appointment</Typography>
                <Typography component="h3" fontSize="4em" fontWeight="700">
                  confirmed!
                </Typography>
              </DialogContentText>
            </DialogContent>
          </Box>
        )}
      </Dialog>
      {/* Success */}
      <SuccessDialog
        open={showSuccess}
        onClose={closeSuccess}
        message="Your appointment booked successfully"
      />
      {/* Alert */}
      <MessagePopup
        msgOpen={showAlert}
        msgText={alertMessage}
        onMsgClose={closeAlert}
      />

      <Grid container xs={12} className="container my-1 mx-2">
        <Grid xs={6} alignSelf="Center">
          <Stack className="logo-sec" direction="row">
            <Box component="img" src={Infopoint_Logo} />
            <h1>Infopoint</h1>
          </Stack>
        </Grid>
        <Grid xs={6} alignSelf="Center" className="text-right">
          <Button className="btn-primary link-btn" sx={{ height: "auto" }}>
            <a href="https://infopoint.com/" target="_blank" alignSelf="Center">
              Visit Site
            </a>
          </Button>
        </Grid>
      </Grid>

      <Stack className="login-sec">
        <Grid
          className="login-bg container-fluid"
          sx={{
            backgroundImage:
              "url(https://www.elieladysalon.com/assets/img/gtt.jpg)",
          }}
        >
          <Grid xs={12} className="container my-1 mx-2" alignSelf="end">
            <Grid container>
              <Grid
                xs={12}
                sm={6}
                md={6}
                alignSelf="End"
                className="login-title"
              >
                <h1 className="h1 text-white">
                  Stay connected with <br /> your business always!
                </h1>
                <p className="mt-3">
                  <a
                    href="https://infopoint.com/"
                    target="_blank"
                    className="white-text"
                  >
                    Explore more{" "}
                    <Box
                      component="img"
                      sx={{ height: 16, width: 16 }}
                      style={{ cursor: "pointer" }}
                      alt="Contact us"
                      src={up_arrow}
                    />
                  </a>
                </p>
              </Grid>
              <Grid xs={12} sm={6} md={6} className="login-form">
                <form>
                  <div className="lg-sec form-sec"></div>
                </form>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Stack>

      <Grid container xs={12} className="container" my={3}>
        <Stack
          direction="row"
          spacing={3}
          justifyContent="space-between"
          width="100%"
        >
          <Stack direction="row" spacing={3}>
            <Avatar sx={{ width: "120px", height: "120px", padding: "4px" }}>
              {/* <Box className="brandLogo">H</Box> */}
              <Box
                className="brandLogo"
                sx={{
                  "background-image": `url(${branchLogoURL})`,
                  "background-color": "#000",
                  filter: "invert(1)",
                }}
              ></Box>
            </Avatar>
            <Stack alignSelf="center">
              <Typography component="h3" fontSize="4rem" fontWeight="800">
                {branchDetails?.branchName}
              </Typography>
              <Typography fontSize="16px">
                <EventIcon sx={{ fontSize: "18px" }} alignSelf="center" />{" "}
                &nbsp; Open all days from{" "}
                {Utils.GetTime(branchDetails?.startTime)} to{" "}
                {Utils.GetTime(branchDetails?.endTime)}
              </Typography>
              <Typography fontSize="16px">
                <PlaceIcon sx={{ fontSize: "18px" }} alignSelf="center" />{" "}
                &nbsp; {branchDetails?.address}
              </Typography>
            </Stack>
          </Stack>
          <Stack spacing={3} alignSelf="center">
            <Link href="#" target="_blank" alignSelf="end">
              <ShareOutlinedIcon sx={{ fontSize: "32px" }} />
            </Link>
            <Button
              variant="outlined"
              endIcon={<ExpandMoreOutlinedIcon />}
              sx={{ fontSize: "16px" }}
            >
              Details
            </Button>
          </Stack>
        </Stack>

        <Grid container mt={6} spacing={4}>
          {showTime && (
            <Grid item xs={12} sm={6} md={6}>
              <Stack direction="row" spacing={1}>
                <IconButton
                  sx={{ alignItems: "center", alignSelf: "center" }}
                  title="Go back to select services"
                  onClick={handleShowServices}
                >
                  <ArrowBackIosIcon sx={{ fontSize: "24px" }} />
                </IconButton>
                <Typography component="h3" fontSize="3rem" fontWeight="800">
                  Select Time
                </Typography>
              </Stack>
              <Stack spacing={2} sx={{ width: "100%" }} mt={2}>
                <Box>
                  <Typography
                    component="h3"
                    fontSize="2rem"
                    fontWeight="600"
                    sx={{ margin: "20px 0 0 0" }}
                  >
                    March 2025
                  </Typography>
                </Box>
                <Box sx={{ width: "660px" }}>
                  <Tabs
                    className="cs-tabs"
                    sx={{ paddingRight: "40px" }}
                    value={timeValue}
                    onChange={handleTimeTabsChange}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                    sx={{
                      [`& .${tabsClasses.scrollButtons}`]: {
                        "&.Mui-disabled": { opacity: 0.3 },
                      },
                    }}
                    aria-label="scrollable auto tabs example"
                  >
                    {reservationDetails?.times?.map((item, itemindex) => (
                      <Tab
                        label={
                          <div>
                            <h4>{item.day}</h4> <span>{item.dayName}</span>
                          </div>
                        }
                        {...a11yProps({ itemindex })}
                      />
                    ))}
                  </Tabs>
                </Box>
                {reservationDetails?.times?.map((item, index) => (
                  <CustomTabPanel value={timeValue} index={index}>
                    {item?.slots?.map((slotObject, timeIndex) => {
                      const neededSlots = Math.ceil(
                        totalTime / branchDetails?.reservationTimeInterval
                      );

                      const selectedSlots = item.slots.slice(
                        timeIndex,
                        timeIndex + neededSlots
                      );
                      // Check if this and next N-1 slots are available
                      const isContinuouslyAvailable =
                        selectedSlots.length === neededSlots && // check if enough slots exist
                        selectedSlots.every((s) => s.isAvailable); // and all are available

                      return (
                        <>
                          {isContinuouslyAvailable && (
                            <Card className="card" key={timeIndex}>
                              <Stack padding={2} paddingRight="70px">
                                <label>
                                  <Typography
                                    component="h3"
                                    fontSize="2.2rem"
                                    fontWeight="700"
                                  >
                                    {slotObject.time}
                                  </Typography>
                                  <Box className="select-service">
                                    <input
                                      type="radio"
                                      name={item.day}
                                      value={slotObject.time}
                                      disabled={!isContinuouslyAvailable}
                                      checked={
                                        selectedTimestring ===
                                          slotObject.time &&
                                        selectedDaystring === item.day
                                      }
                                      onChange={(e) => {
                                        setSelectedTimeString(e.target.value);
                                        setSelectedDaystring(item.day);
                                        setSelectedMonthString(item.month);
                                        setSelectedTime(
                                          PublicReservationHelper.formatCustomDate(
                                            e.target.value,
                                            item.day,
                                            item.month,
                                            serviceStartTime
                                          )
                                        );
                                      }}
                                    />
                                  </Box>
                                </label>
                              </Stack>
                            </Card>
                          )}
                        </>
                      );
                    })}
                  </CustomTabPanel>
                ))}
              </Stack>
            </Grid>
          )}
          {showServies && (
            <Grid item xs={12} sm={6} md={6}>
              <Typography component="h3" fontSize="3rem" fontWeight="800">
                Select Services
              </Typography>
              <Box sx={{ width: "100%" }} mt={2}>
                <Box sx={{ width: "660px", marginBottom: "16px" }}>
                  <Tabs
                    className="cs-tabs"
                    sx={{ paddingRight: "40px" }}
                    value={serviceValue}
                    onChange={handleServiceTabsChange}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                    sx={{
                      [`& .${tabsClasses.scrollButtons}`]: {
                        "&.Mui-disabled": { opacity: 0.3 },
                      },
                    }}
                    aria-label="scrollable auto tabs example"
                  >
                    {/* {serviceCategory.map((sc, index) => (
                      <Tab key={sc} label={sc} {...a11yProps(index)} />
                    ))} */}

                    {Object.keys(categorizedServices).map((category, index) => (
                      <Tab
                        key={category}
                        label={category}
                        {...a11yProps(index)}
                      />
                    ))}
                  </Tabs>
                </Box>

                {Object.keys(categorizedServices).map((category, index) => (
                  <CustomTabPanel
                    key={category}
                    value={serviceValue}
                    index={index}
                  >
                    {categorizedServices[category].map(
                      (service, serviceIndex) => (
                        <ServiceItem
                          key={serviceIndex}
                          title={service.shortDesc}
                          duration={Utils.ConvertMinutesToTimeString(
                            service.serviceTime + service.postServiceTime
                          )}
                          price={Utils.GetCurrency(service.price)}
                          selected={selectedServices.includes(service.id)}
                          onToggle={() => handleToggle(service.id)}
                        />
                      )
                    )}
                  </CustomTabPanel>
                ))}
              </Box>
            </Grid>
          )}
          <Grid item xs={12} sm={1} md={1}></Grid>
          <Grid item xs={12} sm={5} md={5}>
            <Card className="card" sx={{ position: "sticky", top: "30px" }}>
              <Stack
                padding={3}
                spacing={1}
                sx={{ borderBottom: 1, borderColor: "divider" }}
              >
                <Typography
                  component="h3"
                  fontSize="2.2rem"
                  fontWeight="700"
                  marginBottom="10px"
                >
                  {branchDetails?.branchName}
                </Typography>
                {showTime && (
                  <Typography fontSize="16px" fontWeight="700">
                    <EventIcon sx={{ fontSize: "16px" }} alignSelf="center" />{" "}
                    &nbsp; {selectedTime || "None"}
                  </Typography>
                )}
                <Typography fontSize="16px">
                  <PlaceIcon sx={{ fontSize: "16px" }} alignSelf="center" />{" "}
                  &nbsp; {branchDetails?.address}
                </Typography>
              </Stack>

              <Stack padding={3} spacing={3}>
                {selectedServices?.map((service, index) => (
                  <Stack
                    key={index}
                    justifyContent="space-between"
                    direction="row"
                    mb={2} // optional spacing between items
                  >
                    <Box sx={{ flex: 1 }}>
                      <Typography
                        component="h3"
                        fontSize="2rem"
                        fontWeight="600"
                      >
                        {serviceList.find((x) => x.id === service)?.shortDesc}
                      </Typography>
                      <Typography fontSize="1.4rem">
                        {Utils.ConvertMinutesToTimeString(
                          serviceList.find((x) => x.id === service)
                            ?.serviceTime +
                            serviceList.find((x) => x.id === service)
                              ?.postServiceTime
                        )}
                      </Typography>
                    </Box>
                    <Typography
                      component="h3"
                      fontSize="1.6rem"
                      fontWeight="700"
                    >
                      {Utils.GetCurrency(
                        serviceList.find((x) => x.id === service)?.price
                      )}
                    </Typography>
                  </Stack>
                ))}

                <Stack
                  justifyContent="space-between"
                  direction="row"
                  sx={{ borderTop: 1, borderColor: "divider" }}
                  paddingTop={2}
                >
                  <Typography component="h3" fontSize="2rem" fontWeight="600">
                    Total
                  </Typography>
                  <Typography component="h3" fontSize="2rem" fontWeight="700">
                    {Utils.GetCurrency(
                      selectedServices?.reduce((sum, serviceId) => {
                        const service = serviceList.find(
                          (x) => x.id === serviceId
                        );
                        return sum + (service?.price || 0);
                      }, 0)
                    )}
                  </Typography>
                </Stack>
              </Stack>

              <Stack padding={3} mt={2}>
                {showServies && (
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    size="large"
                    className="submitBtn cs-btn"
                    fullWidth="true"
                    onClick={handleShowTime}
                  >
                    Continue
                  </Button>
                )}

                {showTime && (
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    size="large"
                    className="submitBtn cs-btn"
                    fullWidth="true"
                    onClick={handleClickOpenModal}
                  >
                    Book Now
                  </Button>
                )}
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default BrandHome;
